module.exports = __webpack_public_path__ + "assets/denomination-off.38741112.svg";